<footer class="content-footer">
    <div class="footer">
        <div class="copyright">
            <span>{{ 'layout.portal-footer.copy-right' | translate }}</span>

            <span class="go-right">
                <a
                    href="https://joinin2.com/termsconditions/"
                    class="text-gray mrg-right-15"
                >
                    {{ 'layout.portal-footer.terms' | translate }}
                </a>
                <a href="https://joinin2.com/privacy/" class="text-gray">
                    {{ 'layout.portal-footer.privacy' | translate }}
                </a>
            </span>
        </div>
    </div>
</footer>
